import { useState, forwardRef, useImperativeHandle, useContext, useEffect } from 'react';
import { Row, Col, Input, message } from 'antd';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss';
import { AppContext } from '@utils/AppContext';
import API from '@api/api.js';
import eventBus from '@utils/eventBus';
import Iconfont from '@utils/Iconfont';

const EditNameModal = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        setEditNameVisible
    }));
    const { globalOrgInfo } = useContext(AppContext);
    const [editNameVisible, setEditNameVisible] = useState(false)
    const [orgName, setOrgName] = useState()

    useEffect(() => {
        if (editNameVisible) {
            setOrgName(globalOrgInfo?.current?.orgName)
        }
    }, [editNameVisible])

    const postSaveOrg = () => {
        if (!localStorage.getItem('token') || !orgName) return
        API.postSaveOrg({
            orgName,
            orgId: globalOrgInfo?.current?.id,
        }).then((res) => {
            if (res.code == 0) {
                setEditNameVisible(false)
                eventBus.emit('getUserOrgInfo')
            } else {
                message.error(res.message)
            }
        })
    }

    return (
        <PSAIModal
            title='修改团队名称'
            maxWidth={400}
            okText={'确定'}
            open={editNameVisible}
            maskClosable={false}
            okButtonProps={{ disabled: false, loading: false }}
            onCancel={() => setEditNameVisible(false)}
            onOk={() => postSaveOrg()}
        >
            <div className={styles.editNameContent}>
                <Input
                    prefix={<Iconfont className={styles.Icon} type="icon-reuseOutlined" />}
                    value={orgName}
                    onChange={(e) => setOrgName(e.target.value)}
                    maxLength={20}
                    placeholder='请输入团队名称' />
            </div>
        </PSAIModal>
    );
});

export default EditNameModal;